import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from "@mui/lab";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { getActorInfo, formatActorDate } from "../../utils/onBehalf";

const FullDetailsRegularization = ({
  data,
  getStatusData,
  getEmployeeName,
  usersList,
}) => {
  const entries = data?.entries;
  const noOfDays = data?.entries.length;

  const { employeesList } = useSelector((state) => state.notification);
  const resolvedList = usersList?.length ? usersList : employeesList;
  const columns = [
    { field: "id", headerName: "S no.", width: 80, sortable: false },
    { field: "date", headerName: "Date", width: 200, sortable: false },
    {
      field: "approveReject",
      headerName: "Approve/Reject",
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <p className={`${getStatusData(params.row.approveReject).style}`}>
          {params.row.approveReject}
        </p>
      ),
    },
    {
      field: "adminRemarks",
      headerName: "Admin Remarks",
      width: 200,
      sortable: false,
    },
    { field: "inTime", headerName: "In Time", width: 100, sortable: false },
    { field: "outTime", headerName: "Out Time", width: 150, sortable: false },
    { field: "remarks", headerName: "Remarks", flex: 1, sortable: false },
  ];
  const rowData = entries.map((row, index) => ({
    id: index + 1,
    date: row.date,
    approveReject: data.status,
    adminRemarks: data.rejectionReason || "-",
    inTime: row.inTime.hour + ":" + row.inTime.minute,
    outTime: row.outTime.hour + ":" + row.outTime.minute,
    remarks: row.reason || "-",
  }));
  const getCcNames = () => {
    let cCNames = "";
    data.ccList.map((each) => {
      const name = resolvedList.find((item) => item.id === each);
      cCNames = cCNames + name.name + ", ";
    });
    return cCNames.trim(",");
  };
  const applicant = getActorInfo({
    actorId: data?.appliedBy,
    actorName: data?.appliedByName || getEmployeeName("appliedBy"),
    actorRole: data?.appliedByRole,
    ownerId: data?.employeeId,
    ownerName: getEmployeeName("employeeId"),
  });
  const getApproverOrRejectedName = (prop) => {
    const name = resolvedList.find((each) => each?.id === data[prop]);
    return name?.name || "-";
  };

  const timeLineContent = () => {
    switch (data.status) {
      case "PENDING":
        return (
          <>
            <p className="text-black">Pending With</p>
            <p className="text-black font-bold">
              {getApproverOrRejectedName("appliedTo")}
            </p>
          </>
        );
      case "APPROVED":
        return (
          <>
            <p className="text-black">Approved by</p>
            <p className="text-black font-bold">
              {getApproverOrRejectedName("approvedBy")}
            </p>
            <p className="text-xs">
              {dayjs(data.updatedDate + "Z").format("DD MMM YYYY, hh:mm A")}
            </p>
          </>
        );
      case "REJECTED":
        return (
          <>
            <p className="text-black">Rejected by</p>
            <p className="text-black font-bold">
              {getApproverOrRejectedName("rejectedBy")}
            </p>
            <p className="text-xs">
              {dayjs(data.updatedDate + "Z").format("DD MMM YYYY, hh:mm A")}
            </p>
          </>
        );
      case "WITHDRAWAL":
        return (
          <>
            <p className="text-black">Withdrawn by</p>
            <p className="text-black font-bold">
              {getApproverOrRejectedName("employeeId")}
            </p>
            <p className="text-xs">
              {dayjs(data.updatedDate + "Z").format("DD MMM YYYY, hh:mm A")}
            </p>
          </>
        );
      default:
        return "";
    }
  };
  return (
    <div className="flex gap-5">
      <div className="w-[75%] flex gap-3 flex-col">
        <div className="border border-gray-300 p-5">
          <div className="flex justify-between font-medium">
            <p>{getStatusData().displayMessage}</p>
            <p className={`${getStatusData().style}`}>{data?.status}</p>
          </div>
          <div className="bg-blue-100 flex justify-between m-3 p-3  border border-gray-300 rounded-md font-normal shadow-md">
            <p>Remarks: {data?.remarks || "-"}</p>
            <p className="border-l-2 border-[#36454F] pl-5">
              No.of days {noOfDays}
            </p>
          </div>
          {data.ccList.length !== 0 && (
            <div className=" flex justify-start gap-3 p-3">
              <div>
                <p className="font-bold">Details</p>
                <p className="font-semibold text-gray-400">CC to:</p>
              </div>
              <p className="self-end">{getCcNames()}</p>
            </div>
          )}
        </div>

        <div className="border border-gray-300 rounded-2xl p-2 bg-white h-auto">
          <p className="m-3 font-medium">Date applied for regularization.</p>
          <DataGrid
            rows={rowData}
            columns={columns}
            hideFooterPagination
            rowHeight={50}
            disableColumnMenu
            disableColumnFilter
            hideFooter
            rowSelection={false}
            autoHeight={true}
            sx={{
              fontSize: 14,
              fontFamily: "sans-serif",
              "& .MuiDataGrid-columnHeaderTitle": {
                overflow: "scroll",
                lineHeight: "1.43rem",
                whiteSpace: "normal",
                fontSize: "0.875rem",
              },
            }}
            columnHeaderHeight={60}
          />
        </div>
      </div>

      <div className="w-[25%] h-fit">
        <div className="border mt-1 border-gray-300 rounded-2xl bg-white w-[100%] h-full mr-4">
          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0,
              },
            }}
            className="my-6"
          >
            <p>Application TimeLine</p>
            <TimelineItem>
              <TimelineSeparator className="h-44">
                <TimelineDot color="success" />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>{timeLineContent()}</TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot color="primary" />
              </TimelineSeparator>
              <TimelineContent>
                {applicant.isOnBehalf ? (
                  <>
                    <p className="text-black">Applied by</p>
                    <p className="text-black font-bold">
                      {applicant.actorName}
                      {applicant.roleLabel ? ` (${applicant.roleLabel})` : ""}
                    </p>
                    <p className="text-black text-sm">
                      on behalf of {getEmployeeName("employeeId")}
                    </p>
                  </>
                ) : (
                  <>
                    <p className="text-black">Submitted by</p>
                    <p className="text-black font-bold">{getEmployeeName("appliedBy")}</p>
                  </>
                )}
                <p className="text-xs">{formatActorDate(data.createdDate)}</p>
              </TimelineContent>
            </TimelineItem>
          </Timeline>
        </div>
      </div>
    </div>
  );
};

export default FullDetailsRegularization;
